export default __webpack_public_path__ + "static/evadim1-d82c2f517d18f4c46ff5383b887e6030.png";